import { PrinterType } from '@core/services/system/receipt-printers/enum/printer-type.enum';

/**
 * Raised by a printer service when the underlying plugin reports that the
 * printer's connection port/channel is currently occupied by another client
 * (typically cross-device contention on a shared network printer).
 *
 * Surfacing this as a distinct error type lets the print queue apply a
 * dedicated retry policy (longer backoff with jitter, separate attempt
 * budget) without affecting handling of unrelated failures such as paper
 * out, cover open, or fatal protocol errors.
 */
export class PrinterBusyError extends Error {
  constructor(public readonly printerType: PrinterType, public readonly originalMessage: string, public readonly originalError?: unknown) {
    super(`[${printerType}] Printer is busy: ${originalMessage}`);
    this.name = 'PrinterBusyError';

    // Preserve prototype chain across the TS down-level emit so that
    // `error instanceof PrinterBusyError` works reliably at consumer sites.
    Object.setPrototypeOf(this, PrinterBusyError.prototype);
  }
}
